import { dew as _configurationsDew } from "../../configurations";
import { dew as _chronoDew } from "../../chrono";
import { dew as _SlashDateFormatParserDew } from "../../common/parsers/SlashDateFormatParser";
import { dew as _ESWeekdayParserDew } from "./parsers/ESWeekdayParser";
import { dew as _ESTimeExpressionParserDew } from "./parsers/ESTimeExpressionParser";
import { dew as _ESMergeDateTimeRefinerDew } from "./refiners/ESMergeDateTimeRefiner";
import { dew as _ESMergeDateRangeRefinerDew } from "./refiners/ESMergeDateRangeRefiner";
import { dew as _ESMonthNameLittleEndianParserDew } from "./parsers/ESMonthNameLittleEndianParser";
import { dew as _ESCasualDateParserDew } from "./parsers/ESCasualDateParser";
import { dew as _ESCasualTimeParserDew } from "./parsers/ESCasualTimeParser";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createConfiguration = exports.createCasualConfiguration = exports.parseDate = exports.parse = exports.strict = exports.casual = void 0;
  const configurations_1 = _configurationsDew();
  const chrono_1 = _chronoDew();
  const SlashDateFormatParser_1 = __importDefault(_SlashDateFormatParserDew());
  const ESWeekdayParser_1 = __importDefault(_ESWeekdayParserDew());
  const ESTimeExpressionParser_1 = __importDefault(_ESTimeExpressionParserDew());
  const ESMergeDateTimeRefiner_1 = __importDefault(_ESMergeDateTimeRefinerDew());
  const ESMergeDateRangeRefiner_1 = __importDefault(_ESMergeDateRangeRefinerDew());
  const ESMonthNameLittleEndianParser_1 = __importDefault(_ESMonthNameLittleEndianParserDew());
  const ESCasualDateParser_1 = __importDefault(_ESCasualDateParserDew());
  const ESCasualTimeParser_1 = __importDefault(_ESCasualTimeParserDew());
  exports.casual = new chrono_1.Chrono(createCasualConfiguration());
  exports.strict = new chrono_1.Chrono(createConfiguration(true));
  function parse(text, ref, option) {
    return exports.casual.parse(text, ref, option);
  }
  exports.parse = parse;
  function parseDate(text, ref, option) {
    return exports.casual.parseDate(text, ref, option);
  }
  exports.parseDate = parseDate;
  function createCasualConfiguration(littleEndian = true) {
    const option = createConfiguration(false, littleEndian);
    option.parsers.push(new ESCasualDateParser_1.default());
    option.parsers.push(new ESCasualTimeParser_1.default());
    return option;
  }
  exports.createCasualConfiguration = createCasualConfiguration;
  function createConfiguration(strictMode = true, littleEndian = true) {
    return configurations_1.includeCommonConfiguration({
      parsers: [new SlashDateFormatParser_1.default(littleEndian), new ESWeekdayParser_1.default(), new ESTimeExpressionParser_1.default(), new ESMonthNameLittleEndianParser_1.default()],
      refiners: [new ESMergeDateTimeRefiner_1.default(), new ESMergeDateRangeRefiner_1.default()]
    }, strictMode);
  }
  exports.createConfiguration = createConfiguration;
  //# sourceMappingURL=index.js.map
  return exports;
}